import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { formValidationSchema } from 'common/functions/form-validation-schema';
import { selectDistanceOptions } from 'common/hooks/useSelectOptions';
import { useSearchDistance } from 'common/hooks/useZipCodeValidation';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';
import { WsFormTextField } from 'stories/forms/WsFormTextField';
import { WsNativeSelect } from 'stories/inputs/WsNativeSelect';
import * as yup from 'yup';

interface FormValues {
  zipCode: string;
}

const DistanceZipOptions = () => {
  const dispatch = useDispatch();
  const distance = useSelector((state: RootState) => searchParamSelectors.distance(state));
  const zipCodeObj = useSelector((state: RootState) => searchParamSelectors.zipCodeObj(state));
  const [initialValues, setInitialValues] = React.useState<FormValues>({ zipCode: '' });

  React.useEffect(() => {
    setInitialValues({ zipCode: zipCodeObj ? zipCodeObj.code : '' });
  }, [zipCodeObj]);

  const validationSchema = yup.object().shape({
    zipCode: formValidationSchema.zipCode,
  });
  const { searchZipCodeValidate } = useSearchDistance<FormValues>(validationSchema);

  const handleDistanceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(searchParamActions.distance(event.target.value));
  };

  return (
    <>
      <Typography variant="h6">Distance:</Typography>
      <Formik
        validationSchema={validationSchema}
        validateOnChange={false}
        validate={searchZipCodeValidate}
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={_ => {
          return;
        }}
      >
        {props => (
          <Grid container gap={2} alignItems="center" component="form">
            <WsNativeSelect
              id="distance"
              fsx={{
                position: 'relative',
                top: '6px',
              }}
              width={175}
              data={selectDistanceOptions}
              value={distance}
              onChange={handleDistanceChange}
            />
            <WsFormTextField id="zipCode" label="Zip Code" formik={props} size="small" width={80} useCheck />
          </Grid>
        )}
      </Formik>
    </>
  );
};

export default DistanceZipOptions;
